import React from 'react';
import Hero from '../components/Hero';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  // Manifesto sayfasına giderken sayfayı en üste kaydırmak için
  const handleManifestoClick = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div>
      <Hero />
      
      {/* Genel Kurul Değerlendirmesi */}
      <section className="section bg-odtu-light-gray py-12">
        <div className="container">
          <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold text-center mb-6 text-odtu-red">Genel Kurul Değerlendirmesi ve Teşekkür Mesajı</h2>
            <div className="space-y-4 text-odtu-gray">
              <p>
                16-17 Mart 2025 tarihlerinde gerçekleştirilen İstanbul ODTÜ Mezunları Derneği (ODTÜMİST) 25. Olağan Seçimli Genel Kurulu'na katılarak destek veren tüm mezunlarımıza ve üyelerimize teşekkür ederiz.
              </p>
              <p>
                ODTÜ'lülerin dayanışma kültürünü ve katılımcı iradesini bir kez daha ortaya koyduğu bu süreçte, gönüllü grubumuz ODTÜlüyüzBiz olarak seçime katılan üyelerimizin yaklaşık %49'unun oyunu alarak seçime çok yakın bir sonuçla katkı sunduk. Bu sonuç, derneğimizin geleceğine dair ortak sorumluluğumuzun bir göstergesidir.
              </p>
              <p>
                Genel kurul sürecinde edindiğimiz gözlemler, üyelerden gelen geri bildirimler ve önümüzdeki dönem için belirlediğimiz öncelikler doğrultusunda bir değerlendirme ve takip raporu hazırladık. Bu raporda özellikle burs fonunun şeffaf yönetimi, mali tablo açıklığı, katılımı artıracak uygulamalar ve genç mezunlara yönelik stratejiler öne çıkmaktadır.
              </p>
              <p>
                Amacımız; şeffaf, kapsayıcı ve gelişmeye açık bir dernek kültürünün güçlenmesine katkı sunmak, tüm üyelerimizin sürece aktif katılımını teşvik etmektir. ODTÜMİST hepimizin derneğidir. Birlikte daha güçlü, kapsayıcı, şeffaf ve üretken bir yapı oluşturacağımıza olan inancımız tamdır.
              </p>
              <p>
                Ayrıca ülkemiz ve demokrasi için mücadele eden tüm öğrencilerin yanında olduğumuzu belirtmek isteriz.
              </p>
              <p className="font-medium">
                Dayanışmamızın büyüyerek devam etmesi dileğiyle…
              </p>
              <p className="text-right font-bold text-odtu-red">
                ODTÜlüyüzBiz Gönüllü Grubu
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-8">Neden ODTÜlüyüzBiz?</h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-odtu-light-gray p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3">Vizyonumuz</h3>
                <p className="text-odtu-gray">
                  ODTÜ mezunları arasında güçlü bir dayanışma ağı oluşturmak, mezunlarımızın profesyonel ve sosyal gelişimlerine katkıda bulunmak ve ODTÜ'nün değerlerini topluma yaymak.
                </p>
              </div>
              
              <div className="bg-odtu-light-gray p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-3">Misyonumuz</h3>
                <p className="text-odtu-gray">
                  Şeffaf, katılımcı ve kapsayıcı bir yönetim anlayışıyla, tüm mezunlarımızın sesini duyuran, öğrencilerimize destek olan ve ODTÜ ruhunu yaşatan bir dernek yönetimi.
                </p>
              </div>
            </div>
            
            <div className="mt-12 text-center">
              <h3 className="text-2xl font-bold mb-4">16 Mart 2025 - Seçimli Genel Kurul</h3>
              <p className="mb-6">
                ODTÜ İstanbul Mezunları Derneği Seçimli Genel Kurulu'nda ODTÜlüyüzBiz ekibi olarak desteğinizi bekliyoruz.
              </p>
              <div className="inline-block">
                <Link to="/contact" className="btn btn-primary">
                  Bize Katılın
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section bg-odtu-light-gray">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-8">Önceliklerimiz</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-3">
                  <svg className="h-6 w-6 mr-2 text-odtu-red" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  <h3 className="text-xl font-semibold">Mezun Dayanışması</h3>
                </div>
                <p className="text-odtu-gray">
                  Mezunlar arasında güçlü bir iletişim ve dayanışma ağı oluşturmak.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-3">
                  <svg className="h-6 w-6 mr-2 text-odtu-red" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  <h3 className="text-xl font-semibold">Öğrenci Desteği</h3>
                </div>
                <p className="text-odtu-gray">
                  ODTÜ öğrencilerine burs, staj ve mentorluk imkanları sağlamak.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-3">
                  <svg className="h-6 w-6 mr-2 text-odtu-red" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <h3 className="text-xl font-semibold">Şeffaf Yönetim</h3>
                </div>
                <p className="text-odtu-gray">
                  Dernek yönetiminde şeffaflık, hesap verebilirlik ve katılımcılık.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-center mb-3">
                  <svg className="h-6 w-6 mr-2 text-odtu-red" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <h3 className="text-xl font-semibold">ODTÜ Değerlerini Yaşatmak</h3>
                </div>
                <p className="text-odtu-gray">
                  ODTÜ'lü olma değerlerinin kuşaklar arasında aktarılması, yaşatılmasına aracı olacak iletişim kanallarını geliştirmek.
                </p>
              </div>
            </div>
            
            <div className="mt-8 text-center">
              <Link to="/manifesto" className="btn btn-outline" onClick={handleManifestoClick}>
                Tüm Manifestomuzu Okuyun
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 